module.exports = __webpack_public_path__ + "static/media/logoDarkClose.732f3bf0.svg";